import React from "react";

class PageRoot extends React.Component<React.HTMLAttributes<HTMLDivElement>> {
    public render(): React.ReactElement<HTMLDivElement> {
        const { children, ...rest } = this.props;
        return (
            <div className="page-root" {...rest}>
                {children}
            </div>
        );
    }
}

class GradHolder extends React.Component<React.HTMLAttributes<HTMLDivElement>> {
    public render(): React.ReactElement {
        const { children, ...rest } = this.props;
        return (
            <div className="gradholder" {...rest}>
                {children}
            </div>
        );
    }
}

class Grad extends React.Component<React.HTMLAttributes<HTMLDivElement>> {
    public render(): React.ReactElement {
        const { children, ...rest } = this.props;
        return (
            <div className="grad" {...rest}>
                {children}
            </div>
        );
    }
}

export { PageRoot, GradHolder, Grad };
